import React from "react";
import contentfulSeriesApp, { fetchProps } from "@insightfulscience/contentful/Apps/Series";
import { useLocale, WithLocale } from "@insightfulscience/i18";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import AcademyToC from "@src/AcademyToC";
import SectionTryForFree from "@src/SectionTryForFree";
import SiteLayout from "@src/SiteLayout";
import { contentfulProps } from "@src/config";
import resources from "../../locales/series-page";

const seriesLayout = ({ children }) => {
	const [t] = useLocale("series");
	return (
		<SiteLayout hero>
			<PageMeta>
				<PageMeta.Twitter image={t("META_TWITTER_IMAGE")} isImageBaseUrl />
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};
const ContentfulSeriesApp = contentfulSeriesApp({
	Layout: pipe(seriesLayout, WithLocale({ resources })),
	contentfulProps,
	pageProps: {
		brandCode: "sg",
		siteDomain: "https://www.snapgene.com",
		academyToCComponent: {
			Component: AcademyToC,
		},
	},
	mode: "isr",
});

export const getStaticPaths = async () => ({
	paths: [],
	fallback: "blocking",
});
export const getStaticProps = async ({ params: { slug } }) => {
	const props = await fetchProps(contentfulProps, slug, false);

	return props?.video
		? {
				props,
				revalidate: false,
		  }
		: { notFound: true };
};

export default ContentfulSeriesApp;
